import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'medpt-checkbox',
    templateUrl: './checkbox.html',
    standalone: false
})
export class CheckBoxComponent {
  @Input() field: any = {};
  @Input() form!: FormGroup;
  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  allDocumentSelected: boolean = true;
  constructor() {

  }

  checkUncheckAll($event: any) {
    const checkArray: FormArray = <FormArray>this.form.get(this.field.uniquename);
    checkArray.clear();
    checkArray.controls = [];
    checkArray.removeAt(0);

    this.field.Answers.forEach((asset: any, index: number) => {
      asset.checked = $event.target.checked;
      if ($event.target.checked) {
        let ctrl = (this.field.IsRequired) ? new FormControl(asset.FormAnswerID, [Validators.required]) : new FormControl(asset.FormAnswerID);
        checkArray.push(ctrl);
      }
    });
  }

  onCheckboxChange(e: any, opt:any) {
    const checkArray: FormArray = this.form.get(this.field.uniquename) as FormArray;
    opt.checked = e.target.checked
    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

}
